import React from "react";
import { Outlet } from "react-router-dom";

export default function Root() {
  return (
    <div>
        <div>
            <img src="https://storage.googleapis.com/knowby-pro-public/logo.png" className="logo"/>
        </div>
        <br/>
        <div className="content">
            <p>
                Looks like you are trying to view a knowby that is available for your organization only, download the
                app and
                start your journey!
            </p>
            <br/><br/>
            <h1>Download Knowby Pro now:</h1>
            <div className="badges">
                <a href="https://apps.apple.com/us/app/knowby-pro/id1607657029">
                    <img src="https://storage.googleapis.com/knowby-pro-public/apple.png" className="badge"/>
                </a>
                <a href="https://play.google.com/store/apps/details?id=net.knowby.worker">
                    <img src="https://storage.googleapis.com/knowby-pro-public/google.png" className="badge"/>
                </a>
            </div>
        </div>
        <h2>© 2023 Knowby. All rights reserved.</h2>
        <Outlet />
    </div>
  );
}
